var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PartnerPage',{attrs:{"title":"Contacts","doc":_vm.doc}},[_c('List',{attrs:{"items":_vm.contacts}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }